import { withAuth } from '@okta/okta-react';
import { CrudList } from '@westernmilling/eu_react_shared';

import Columns from 'helpers/columns/CreditStatuses';
import ItemForm from 'components/Forms/CreditStatus';

export default withAuth(class CreditStatusesContainer extends CrudList {
  auditLogModelType = () => 'Credit::CreditStatus';

  getColumns = () => Columns(this);

  getFormTag = () => ItemForm;

  getListApi = () => 'credit/credit_statuses';

  getStorageName = () => 'otto_credit_statuses_list';

  getAddGroups = () => ['credit_admin'];

  getEditGroups = () => ['credit_admin'];

  getPageTitle = () => 'Credit Statuses';

  canDownloadCsv = () => true;

  getAddText = () => 'Create Credit Status';

  getWidthCenter = () => 8;

  getWidthLeft = () => 2;

  getWidthRight = () => 2;
});
